import React, { useEffect, useState } from 'react';
import { API_URL } from '../config/api';
import './PublicAccess.css';

const ADS_GLOBALLY_ENABLED = false;

const PublicAccess = () => {
  const [nome, setNome] = useState('');
  const [cpf, setCpf] = useState('');
  const [celular, setCelular] = useState('');
  const [macAddress, setMacAddress] = useState('');
  const [ipAddress, setIpAddress] = useState('');
  const [username, setUsername] = useState('');
  const [serverName, setServerName] = useState('');
  const [serverAddress, setServerAddress] = useState('');
  const [identity, setIdentity] = useState('');
  const [origUrl, setOrigUrl] = useState('');
  const [linkLoginOnly, setLinkLoginOnly] = useState('');
  const [chapId, setChapId] = useState('');
  const [chapChallenge, setChapChallenge] = useState('');
  const [aceiteLgpd, setAceiteLgpd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [adConfig, setAdConfig] = useState({
    enabled: false,
    imageUrl: '',
    clickUrl: '',
    delaySeconds: 5
  });
  const [showAd, setShowAd] = useState(false);
  const [canCloseAd, setCanCloseAd] = useState(false);
  const [adCountdown, setAdCountdown] = useState(0);
  const [socialConfig, setSocialConfig] = useState({
    facebook_url: '',
    instagram_url: '',
    facebook_ativo: false,
    instagram_ativo: false
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mac = params.get('mac') || params.get('mac_address') || params.get('macaddr') || '';
    const ip = params.get('ip') || params.get('ip_address') || params.get('client_ip') || '';
    const user = params.get('username') || '';
    const server = params.get('server') || params.get('server_name') || '';
    const ident = params.get('identity') || '';
    const orig = params.get('orig') || params.get('link_orig') || '';
    const loginOnly = params.get('link_login_only') || params.get('link-login-only') || '';
    const chapIdParam = params.get('chap_id') || params.get('chap-id') || '';
    const chapChallengeParam = params.get('chap_challenge') || params.get('chap-challenge') || '';
    const serverAddr = params.get('server_address') || params.get('server-address') || '';

    if (mac) setMacAddress(mac.trim());
    if (ip) setIpAddress(ip.trim());
    if (user) setUsername(user.trim());
    if (server) setServerName(server.trim());
    if (serverAddr) setServerAddress(serverAddr.trim());
    if (ident) setIdentity(ident.trim());
    if (orig) setOrigUrl(orig.trim());
    if (loginOnly) setLinkLoginOnly(loginOnly.trim());
    if (chapIdParam) setChapId(chapIdParam.trim());
    if (chapChallengeParam) setChapChallenge(chapChallengeParam.trim());
  }, []);

  useEffect(() => {
    if (!ADS_GLOBALLY_ENABLED) {
      return;
    }
    const fetchAd = async () => {
      if (!serverName) {
        return;
      }
      try {
        const response = await fetch(`${API_URL}/api/ads?server=${encodeURIComponent(serverName)}`);
        const data = await response.json().catch(() => ({}));
        if (response.ok) {
          setAdConfig({
            enabled: !!data.enabled,
            imageUrl: data.imageUrl || '',
            clickUrl: data.clickUrl || '',
            delaySeconds: Number.isFinite(Number(data.delaySeconds)) ? Number(data.delaySeconds) : 5
          });
        }
      } catch (_err) {
        // Propaganda opcional
      }
    };

    fetchAd();
  }, [serverName]);

  useEffect(() => {
    const fetchSocialConfig = async () => {
      try {
        const response = await fetch(`${API_URL}/api/redes-sociais/public`);
        const data = await response.json().catch(() => ({}));
        if (!response.ok) return;
        setSocialConfig({
          facebook_url: data.facebook_url || '',
          instagram_url: data.instagram_url || '',
          facebook_ativo: !!data.facebook_ativo,
          instagram_ativo: !!data.instagram_ativo
        });
      } catch (_err) {
        // opcional
      }
    };
    fetchSocialConfig();
  }, []);

  const getSocialRedirectUrl = () => {
    const isMobile = /Android|iPhone|iPad|iPod|IEMobile|Opera Mini/i.test(navigator.userAgent || '');
    if (socialConfig.instagram_ativo && socialConfig.instagram_url) {
      return socialConfig.instagram_url.trim();
    }
    if (socialConfig.facebook_ativo && socialConfig.facebook_url) {
      const url = socialConfig.facebook_url.trim();
      if (isMobile) {
        return url.replace('https://www.facebook.com/', 'https://m.facebook.com/');
      }
      return url;
    }
    return '';
  };

  const hexMD5 = (value) => {
    const md5cycle = (x, k) => {
      let [a, b, c, d] = x;
      a = ff(a, b, c, d, k[0], 7, -680876936);
      d = ff(d, a, b, c, k[1], 12, -389564586);
      c = ff(c, d, a, b, k[2], 17, 606105819);
      b = ff(b, c, d, a, k[3], 22, -1044525330);
      a = ff(a, b, c, d, k[4], 7, -176418897);
      d = ff(d, a, b, c, k[5], 12, 1200080426);
      c = ff(c, d, a, b, k[6], 17, -1473231341);
      b = ff(b, c, d, a, k[7], 22, -45705983);
      a = ff(a, b, c, d, k[8], 7, 1770035416);
      d = ff(d, a, b, c, k[9], 12, -1958414417);
      c = ff(c, d, a, b, k[10], 17, -42063);
      b = ff(b, c, d, a, k[11], 22, -1990404162);
      a = ff(a, b, c, d, k[12], 7, 1804603682);
      d = ff(d, a, b, c, k[13], 12, -40341101);
      c = ff(c, d, a, b, k[14], 17, -1502002290);
      b = ff(b, c, d, a, k[15], 22, 1236535329);

      a = gg(a, b, c, d, k[1], 5, -165796510);
      d = gg(d, a, b, c, k[6], 9, -1069501632);
      c = gg(c, d, a, b, k[11], 14, 643717713);
      b = gg(b, c, d, a, k[0], 20, -373897302);
      a = gg(a, b, c, d, k[5], 5, -701558691);
      d = gg(d, a, b, c, k[10], 9, 38016083);
      c = gg(c, d, a, b, k[15], 14, -660478335);
      b = gg(b, c, d, a, k[4], 20, -405537848);
      a = gg(a, b, c, d, k[9], 5, 568446438);
      d = gg(d, a, b, c, k[14], 9, -1019803690);
      c = gg(c, d, a, b, k[3], 14, -187363961);
      b = gg(b, c, d, a, k[8], 20, 1163531501);
      a = gg(a, b, c, d, k[13], 5, -1444681467);
      d = gg(d, a, b, c, k[2], 9, -51403784);
      c = gg(c, d, a, b, k[7], 14, 1735328473);
      b = gg(b, c, d, a, k[12], 20, -1926607734);

      a = hh(a, b, c, d, k[5], 4, -378558);
      d = hh(d, a, b, c, k[8], 11, -2022574463);
      c = hh(c, d, a, b, k[11], 16, 1839030562);
      b = hh(b, c, d, a, k[14], 23, -35309556);
      a = hh(a, b, c, d, k[1], 4, -1530992060);
      d = hh(d, a, b, c, k[4], 11, 1272893353);
      c = hh(c, d, a, b, k[7], 16, -155497632);
      b = hh(b, c, d, a, k[10], 23, -1094730640);
      a = hh(a, b, c, d, k[13], 4, 681279174);
      d = hh(d, a, b, c, k[0], 11, -358537222);
      c = hh(c, d, a, b, k[3], 16, -722521979);
      b = hh(b, c, d, a, k[6], 23, 76029189);
      a = hh(a, b, c, d, k[9], 4, -640364487);
      d = hh(d, a, b, c, k[12], 11, -421815835);
      c = hh(c, d, a, b, k[15], 16, 530742520);
      b = hh(b, c, d, a, k[2], 23, -995338651);

      a = ii(a, b, c, d, k[0], 6, -198630844);
      d = ii(d, a, b, c, k[7], 10, 1126891415);
      c = ii(c, d, a, b, k[14], 15, -1416354905);
      b = ii(b, c, d, a, k[5], 21, -57434055);
      a = ii(a, b, c, d, k[12], 6, 1700485571);
      d = ii(d, a, b, c, k[3], 10, -1894986606);
      c = ii(c, d, a, b, k[10], 15, -1051523);
      b = ii(b, c, d, a, k[1], 21, -2054922799);
      a = ii(a, b, c, d, k[8], 6, 1873313359);
      d = ii(d, a, b, c, k[15], 10, -30611744);
      c = ii(c, d, a, b, k[6], 15, -1560198380);
      b = ii(b, c, d, a, k[13], 21, 1309151649);
      a = ii(a, b, c, d, k[4], 6, -145523070);
      d = ii(d, a, b, c, k[11], 10, -1120210379);
      c = ii(c, d, a, b, k[2], 15, 718787259);
      b = ii(b, c, d, a, k[9], 21, -343485551);

      x[0] = add32(a, x[0]);
      x[1] = add32(b, x[1]);
      x[2] = add32(c, x[2]);
      x[3] = add32(d, x[3]);
    };

    const cmn = (q, a, b, x, s, t) => add32(rol(add32(add32(a, q), add32(x, t)), s), b);
    const ff = (a, b, c, d, x, s, t) => cmn((b & c) | (~b & d), a, b, x, s, t);
    const gg = (a, b, c, d, x, s, t) => cmn((b & d) | (c & ~d), a, b, x, s, t);
    const hh = (a, b, c, d, x, s, t) => cmn(b ^ c ^ d, a, b, x, s, t);
    const ii = (a, b, c, d, x, s, t) => cmn(c ^ (b | ~d), a, b, x, s, t);

    const md51 = (str) => {
      const n = str.length;
      const state = [1732584193, -271733879, -1732584194, 271733878];
      let i;
      for (i = 64; i <= n; i += 64) {
        md5cycle(state, md5blk(str.substring(i - 64, i)));
      }
      str = str.substring(i - 64);
      const tail = Array(16).fill(0);
      for (i = 0; i < str.length; i += 1) {
        tail[i >> 2] |= str.charCodeAt(i) << ((i % 4) << 3);
      }
      tail[i >> 2] |= 0x80 << ((i % 4) << 3);
      if (i > 55) {
        md5cycle(state, tail);
        for (let j = 0; j < 16; j += 1) tail[j] = 0;
      }
      tail[14] = n * 8;
      md5cycle(state, tail);
      return state;
    };

    const md5blk = (str) => {
      const md5blks = [];
      for (let i = 0; i < 64; i += 4) {
        md5blks[i >> 2] =
          str.charCodeAt(i) +
          (str.charCodeAt(i + 1) << 8) +
          (str.charCodeAt(i + 2) << 16) +
          (str.charCodeAt(i + 3) << 24);
      }
      return md5blks;
    };

    const rhex = (n) => {
      const s = '0123456789abcdef';
      let j;
      let out = '';
      for (j = 0; j < 4; j += 1) {
        out += s.charAt((n >> (j * 8 + 4)) & 0x0f) + s.charAt((n >> (j * 8)) & 0x0f);
      }
      return out;
    };

    const hex = (x) => x.map(rhex).join('');
    const add32 = (a, b) => (a + b) & 0xffffffff;
    const rol = (num, cnt) => (num << cnt) | (num >>> (32 - cnt));

    return hex(md51(value));
  };

  const submitHotspotLogin = (userValue, passValue) => {
    if (!linkLoginOnly) {
      return false;
    }
    let iframe = document.getElementById('hotspot-login-iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.id = 'hotspot-login-iframe';
      iframe.name = 'hotspot-login-iframe';
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
    }
    const form = document.createElement('form');
    form.method = 'post';
    form.action = linkLoginOnly;
    form.target = 'hotspot-login-iframe';
    form.style.display = 'none';

    const redirectTarget = origUrl || 'http://neverssl.com';
    const fields = [
      { name: 'username', value: userValue },
      { name: 'password', value: passValue },
      { name: 'dst', value: redirectTarget }
    ];

    fields.forEach(({ name, value }) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value || '';
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (!aceiteLgpd) {
      setError('É necessário aceitar os termos da LGPD.');
      return;
    }

    setLoading(true);

    const socialUrl = getSocialRedirectUrl();
    let socialPopup = null;
    if (socialUrl) {
      socialPopup = window.open('', 'sysconect-social-popup', 'width=980,height=760');
    }

    try {
      const senha = cpf.trim();
      const usuario = cpf.trim() || macAddress || 'visitante';
      const redirectTarget = origUrl || 'http://neverssl.com';

      if (linkLoginOnly) {
        const passFinal =
          chapId && chapChallenge ? hexMD5(chapId + senha + chapChallenge) : senha;
        submitHotspotLogin(usuario, passFinal);
      }

      const response = await fetch(`${API_URL}/api/acessos`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nome,
          cpf,
          celular,
          mac_address: macAddress || 'UNKNOWN',
          ip_address: ipAddress || '',
          username,
          server: serverName,
          server_address: serverAddress,
          identity,
          orig: origUrl,
          aceite_lgpd: aceiteLgpd
        })
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        if (socialPopup && !socialPopup.closed) {
          socialPopup.close();
        }
        setError(data.error || 'Erro ao enviar dados');
        return;
      }

      setMessage('OK');
      setNome('');
      setCpf('');
      setCelular('');
      setAceiteLgpd(false);

      if (socialUrl) {
        if (socialPopup && !socialPopup.closed) {
          socialPopup.location.href = socialUrl;
          socialPopup.focus();
        } else {
          window.open(socialUrl, '_blank', 'noopener,noreferrer');
        }
      }

      if (ADS_GLOBALLY_ENABLED && adConfig.enabled && adConfig.imageUrl) {
        const delaySeconds = Math.max(1, Number(adConfig.delaySeconds || 5));
        setAdCountdown(delaySeconds);
        setCanCloseAd(false);
        setShowAd(true);
        const interval = setInterval(() => {
          setAdCountdown((prev) => {
            if (prev <= 1) {
              clearInterval(interval);
              setCanCloseAd(true);
              return 0;
            }
            return prev - 1;
          });
        }, 1000);
      } else if (redirectTarget) {
        setTimeout(() => {
          window.location.href = redirectTarget;
        }, 800);
      }
    } catch (_err) {
      setError('Erro ao enviar dados');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="public-access-container">
      <div className="public-access-box">
        <h1>Lorena Digital</h1>
        <h2>Portal de Acesso</h2>
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome</label>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>CPF</label>
            <input
              type="text"
              value={cpf}
              onChange={(e) => setCpf(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <label>Celular</label>
            <input
              type="text"
              value={celular}
              onChange={(e) => setCelular(e.target.value)}
              required
            />
          </div>
          <label className="checkbox-row">
            <input
              type="checkbox"
              checked={aceiteLgpd}
              onChange={(e) => setAceiteLgpd(e.target.checked)}
            />
            Aceito os termos da LGPD
          </label>
          <button type="submit" disabled={loading || !aceiteLgpd}>
            {loading ? 'Enviando...' : 'Enviar'}
          </button>
        </form>
        <div className="public-access-footer">Direitos autorais da Secretaria de Governança Digital.</div>
      </div>
      {showAd && (
        <div className="ad-overlay">
          <div className="ad-modal">
            <div className="ad-header">
              <h3>Propaganda</h3>
              <button
                className="ad-close"
                disabled={!canCloseAd}
                onClick={() => {
                  setShowAd(false);
                  if (origUrl) {
                    window.location.href = origUrl;
                  }
                }}
              >
                {canCloseAd ? 'Fechar' : `Aguarde ${adCountdown}s`}
              </button>
            </div>
            <div className="ad-body">
              {adConfig.clickUrl ? (
                <a href={adConfig.clickUrl} target="_blank" rel="noreferrer">
                  <img src={adConfig.imageUrl} alt="Propaganda" />
                </a>
              ) : (
                <img src={adConfig.imageUrl} alt="Propaganda" />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PublicAccess;
